// What each platform capability gives the agent, and the notes that hold for its contract only.
// Kept in step with packages/connectors in magellan-api: the contracts endpoint has no notes yet.
export const CAPABILITIES = {
  'orders.read': {
    label: 'Order lookup',
    gains: "Answers order and tracking questions from the store's orders. Off: they go to support.",
    notes: [
      'The order tool sends {{args.order}}, not {{args.orderId}}.',
      'Put {{identity.email}} or {{identity.phone}} in the URL or body; {{identity.externalId}} has no live source yet and renders empty.',
    ],
  },
};

export const capabilityLabel = (capability) =>
  CAPABILITIES[capability] ? `${CAPABILITIES[capability].label} · ${capability}` : capability;

// One slot per contract result field: its path from the map, filled or not.
export const slotsOf = (contract, mapRows) =>
  (contract?.resultFields || []).map((field) => ({
    ...field,
    path: mapRows.find((row) => row.key.trim() === field.name)?.value || '',
  }));

export const slotSummary = (slots) => {
  const filled = slots.filter((slot) => slot.path.trim()).length;
  const missing = slots.filter((slot) => slot.required && !slot.path.trim()).length;
  return {
    filled,
    missing,
    text: `${filled} of ${slots.length} · ${missing ? `${missing} required missing` : 'required done'}`,
  };
};

// The map with one slot set; an emptied slot leaves the map rather than saving a blank path.
export const setSlot = (mapRows, name, path) => {
  if (!path) return mapRows.filter((row) => row.key.trim() !== name);
  const index = mapRows.findIndex((row) => row.key.trim() === name);
  if (index === -1) return [...mapRows, { key: name, value: path }];
  return mapRows.map((row, i) => (i === index ? { key: name, value: path } : row));
};

// The slot to fill next: the first empty required one, else the first empty one.
export const nextSlot = (slots, after) => {
  const empty = slots.filter((slot) => !slot.path.trim() && slot.name !== after);
  return (empty.find((slot) => slot.required) || empty[0])?.name || null;
};
